import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=67eb2a2a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb2a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67eb2a2a')) {
      api.createRecord('67eb2a2a', component.options)
    } else {
      api.reload('67eb2a2a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=67eb2a2a&scoped=true&", function () {
      api.rerender('67eb2a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oemp7vQ8aIdh/JS/comp/Voucher-Unit.vue"
export default component.exports